import { render, staticRenderFns } from "./AwardTypeCreate.vue?vue&type=template&id=787ad6c0"
import script from "./AwardTypeCreate.vue?vue&type=script&lang=js"
export * from "./AwardTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports